export default __webpack_public_path__ + "static/media/pinky.8de7a642.png";